{
  "id": "bookshelf",
  "name": "Bookshelf",
  "builds": "product",
  "category": "furniture",
  "note": "The grain you sanded is the grain they see.",
  "skill": "fineShelving",
  "duration": 40,
  "offeredBy": "drill",
  "fastener": "screws",
  "value": 26,
  "widthIn": 48,
  "heightIn": 48,
  "slots": [
    {
      "id": "side-0",
      "role": "side",
      "part": {
        "widthIn": 6,
        "lengthIn": 48,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 2,
      "yIn": 24,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "side-1",
      "role": "side",
      "part": {
        "widthIn": 6,
        "lengthIn": 48,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 46,
      "yIn": 24,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "shelf-0",
      "role": "shelf",
      "part": {
        "widthIn": 6,
        "lengthIn": 48,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 24,
      "yIn": 12,
      "angleDeg": 90,
      "zIn": 6
    },
    {
      "id": "shelf-1",
      "role": "shelf",
      "part": {
        "widthIn": 6,
        "lengthIn": 48,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 24,
      "yIn": 36,
      "angleDeg": 90,
      "zIn": 6
    }
  ],
  "fasteners": [
    {
      "xIn": 2,
      "yIn": 12
    },
    {
      "xIn": 2,
      "yIn": 36
    },
    {
      "xIn": 46,
      "yIn": 12
    },
    {
      "xIn": 46,
      "yIn": 36
    }
  ]
}
